<script>
  import { onMount, onDestroy } from 'svelte';
  import { roomsState } from '../../js/state.js';
  import { joinRoom } from '../../js/actions.js';
  import {
    CHAT_PUBLIC_TITLE,
    CHAT_GENERAL_CHANNEL_NAME,
    ROOM_JOIN_ROOM,
    ROOM_JOIN,
    ROOM_PUBLIC_HEADER,
    ROOM_PRIVATE_HEADER,
  } from '../../js/l10n/en_US.js';

  const DEFAULT_ROOM = [CHAT_GENERAL_CHANNEL_NAME, { room_name: CHAT_PUBLIC_TITLE }];
  export let source,
    id,
    token,
    onClose = () => {};

  let joinRoomName = '',
    privateRooms = [],
    publicRooms = [DEFAULT_ROOM],
    showEnterCode = false;

  function submitJoinRoom() {
    if (joinRoomName == '') {
      return;
    }
    joinRoom(source, id, joinRoomName, token);
    joinRoomName = '';
    onClose();
  }

  function joinRoomID(roomID) {
    if (roomID === CHAT_GENERAL_CHANNEL_NAME) {
      roomsState.setDefaultRoom();
    } else {
      roomsState.setCurrentRoom(roomID);
    }
    onClose();
  }

  $: if ($roomsState && $roomsState.rooms) {
    let rooms = Object.entries($roomsState.rooms);
    privateRooms = rooms.filter((arr) => !arr[1].public);
    publicRooms = rooms.filter((arr) => arr[1].public);
    publicRooms.push(DEFAULT_ROOM);
  }
</script>

<div class="room-select">
  <div class="room-select-section public-rooms-section">
    <div class="section-title">
      <i class="icon-public" />
      <span>{ROOM_PUBLIC_HEADER}</span>
    </div>
    <div class="section-content">
      {#each publicRooms as [roomID, roomData]}
        <div class="section-room" on:click={joinRoomID(roomID)} on:dblclick={onClose()}>
          <i class="icon-chat_bubble_outline" />
          <span>{roomData.room_name}</span>
        </div>
      {/each}
    </div>
  </div>
  {#if privateRooms.length !== 0}
    <div class="room-select-section private-rooms-section">
      <div class="section-title">
        <i class="icon-lock" />
        <span>{ROOM_PRIVATE_HEADER}</span>
      </div>
      <div class="section-content">
        {#each privateRooms as [roomID, roomData]}
          <div class="section-room" on:click={joinRoomID(roomID)} on:dblclick={onClose()}>
            <i class="icon-chat_bubble_outline" />
            <span>{roomData.room_name}</span>
          </div>
        {/each}
      </div>
    </div>
  {/if}

  <div class="join-room-section">
    <div
      class="join-room-section-title"
      on:click={() => {
        showEnterCode = !showEnterCode;
        if (showEnterCode) {
          setTimeout(() => {
            document.getElementById('join-room-input').focus();
          }, 500);
        } else {
          document.getElementById('join-room-input').blur();
        }
      }}>
      {ROOM_JOIN_ROOM}
    </div>
    {#if showEnterCode}
      <div>
        <form on:submit|preventDefault={submitJoinRoom}>
          <input id="join-room-input" bind:value={joinRoomName} />
          <button type="submit" class={joinRoomName === '' ? 'disabled' : ''}>{ROOM_JOIN}</button>
        </form>
      </div>
    {/if}
  </div>
</div>
